import React, { useState, useEffect, useRef } from 'react';
import '../styles/Faq.css';
import HeroMascot2 from '../assets/Hero-Mascot-2.png';

const Faq = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const faqRef = useRef(null);

    useEffect(() => {
        const section = faqRef.current;

        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        if (section) observer.observe(section);

        return () => {
            if (section) observer.unobserve(section);
        };
    }, []);

    const toggleAnswer = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqData = [
        {
            question: 'Apakah kerahasiaan data saya terjamin?',
            answer: 'Ya, kami memastikan bahwa data Anda disimpan dengan aman sesuai dengan kebijakan privasi kami.',
        },
        {
            question: 'Bagaimana mengukur perbuatan merendahkan dan menghina dalam definisi kekerasan seksual?',
            answer: 'Perbuatan tersebut dapat diidentifikasi berdasarkan konteks, niat, dan dampaknya terhadap korban, dengan merujuk pada undang-undang yang berlaku.',
        },
        {
            question: 'Bagaimana cara melapor dugaan tindak kekerasan seksual?',
            answer: 'Anda dapat melapor melalui platform ini dengan mengisi formulir yang telah disediakan secara aman dan terjamin.',
        },
    ];

    return (
        <section
            id="faq"
            className={`faq ${isVisible ? 'slideUp' : ''}`}
            ref={faqRef}
        >
            <h2>Frequently Asked Questions</h2>
            <p className="cari-info">Cari informasi seputar pertanyaanmu di sini ya!</p>
            <div className="faq-container">
                <div className="faq-list">
                    {faqData.map((item, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => toggleAnswer(index)}
                        >
                            <div className="faq-question">
                                <p>{item.question}</p>
                                <span>{activeIndex === index ? '-' : '+'}</span>
                            </div>
                            {activeIndex === index && <div className="faq-answer">{item.answer}</div>}
                        </div>
                    ))}
                </div>
                <div className="faq-image">
                    <img src={HeroMascot2} alt="Ilustrasi FAQ" />
                </div>
            </div>
        </section>
    );
};

export default Faq;
